import React from 'react';
import { Empty } from 'antd';
import { SharedEMSIndividualReport } from './templates/SharedEMSIndividualReport';
import { resolveEMSIndividualConfig } from './reportConfigResolver';

export function EMSIndividualReport(props) {
   const config = resolveEMSIndividualConfig(props.template, props.subject_id);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedEMSIndividualReport {...props} config={config} />;
}
